import unbindNode from './unbindnode/index.js';
import triggerOne from './trigger/_triggerone.js';
import removeListener from './off/_removelistener.js';
import defs from './_core/defs.js';
import deepBindings from './bindnode/_deepbindings.js';
import checkObjectType from './_helpers/checkobjecttype.js';
import matreshkaError from './_helpers/matreshkaerror.js';
import forEach from './_helpers/foreach.js';
import hasOwn from './_helpers/hasown.js';
import assign from './_helpers/assign.js';
export default function remove(object, givenKey, eventOptions) {
  if (typeof this === 'object' && this.isMatreshka) {
    // when context is Matreshka instance, use this as an object and shift other args
    eventOptions = givenKey;
    givenKey = object;
    object = this;
  } else {
    // throw error when object type is wrong
    checkObjectType(object, 'remove');
  }
  eventOptions = eventOptions || {};
  var def = defs.get(object);
  var _eventOptions = eventOptions,
    silent = _eventOptions.silent;
  // allow to pass single key or an array of keys
  var keys = Array.isArray(givenKey) ? givenKey : [givenKey];
  var _loop = function _loop() {
    var _deepBindings$get$fil, _deepBindings$get;
    var key = keys[i];
    // if non-string is passed as a key
    if (typeof key !== 'string') {
      throw matreshkaError('remove:key_type', {
        key: key
      });
    }
    var props = def == null ? void 0 : def.props;
    var propDef = props == null ? void 0 : props[key];
    // a property Matreshka doesn't track is simply deleted, and still announced
    if (!propDef) {
      var existed = hasOwn(object, key);
      var _value = object[key];
      delete object[key];
      if (def && existed && !silent) {
        var _extendedEventOptions = assign({
          key: key,
          value: _value
        }, eventOptions);
        triggerOne(object, 'delete', _extendedEventOptions);
        triggerOne(object, "delete:" + key, _extendedEventOptions);
      }
      return 1; // continue
    }
    var value = propDef.value;
    // remove all bindings, deep ones under the key ("a.b" for "a") too
    unbindNode(object, key);
    forEach((_deepBindings$get$fil = (_deepBindings$get = deepBindings.get(object)) == null ? void 0 : _deepBindings$get.filter(function (_ref) {
      var deepPath = _ref.deepPath;
      return deepPath[0] === key;
    })) != null ? _deepBindings$get$fil : [], function (deepBinding) {
      return unbindNode(object, deepBinding.key);
    });
    // undelegate delegated and tree listeners (a.b@event, calc on "a.b") from the removed value;
    // a listener that another property's delegation also keeps stays
    if (value && typeof value === 'object') {
      triggerOne(object, "_change:delegated:" + key, {
        key: key,
        value: undefined,
        previousValue: value
      });
    }
    // TODO: Manual listing of event prefixes may cause problems in future
    var removeEventPrefies = ['_change:deps', '_change:bindings', '_change:delegated', '_change:tree', 'change', 'beforechange', 'bind', 'unbind', '_bind', '_unbind'];
    // remove all events
    forEach(removeEventPrefies, function (prefix) {
      return removeListener(object, prefix + ":" + key);
    });
    // delete property definition
    delete props[key];
    // delete the property itself
    delete object[key];
    var extendedEventOptions = assign({
      key: key,
      value: value
    }, eventOptions);
    // trigger delegated events logic removal for asterisk events (*.*.*@foo)
    triggerOne(object, '_delete:delegated', extendedEventOptions);
    // fire events if "silent" is not true
    if (!silent) {
      triggerOne(object, 'delete', extendedEventOptions);
      triggerOne(object, "delete:" + key, extendedEventOptions);
    }
  };
  for (var i = 0; i < keys.length; i++) {
    if (_loop()) continue;
  }
  return object;
}